module.exports = __webpack_public_path__ + "img/icon-bbtc.a54cce58.png";